import { lazy, Suspense, useState } from 'react'
import Button from '@/components/ui/button'
import WalletIcon from '@/assets/icons/walletIcon'
import { toastService } from '@/api/toast'
import { i18n } from '@/locale/i18n'
import { preloadWalletRoot } from '@/providers/walletRootLoader'

const WalletSiweSession = lazy(() => import('./WalletSiweSession'))

const reownConfigured = Boolean(String(import.meta.env.VITE_REOWN_PROJECT_ID ?? '').trim())

function preloadWalletAuth() {
  preloadWalletRoot()
  return import('./WalletSiweSession')
}

/**
 * Light wallet CTA. Wagmi / Reown / AppKit load only after the user clicks
 * (or hovers, which warms the chunk).
 */
export default function WalletAuthButton({
  label,
  className,
  disconnectIfConnected = false,
  iconSize = 24,
  trailing = null,
  notConfiguredMessage,
}) {
  const [started, setStarted] = useState(false)
  const [loading, setLoading] = useState(false)

  const start = event => {
    event?.preventDefault()
    event?.stopPropagation()
    if (!reownConfigured) {
      toastService('fail', {
        title: notConfiguredMessage || i18n('hardcoded.wallet_login_not_configured'),
      })
      return
    }
    setLoading(true)
    setStarted(true)
    preloadWalletAuth()
  }

  return (
    <>
      <Button
        onClick={start}
        onMouseEnter={preloadWalletAuth}
        onFocus={preloadWalletAuth}
        onPointerDown={preloadWalletAuth}
        disabled={!reownConfigured}
        loading={loading}
        variant="shade"
        size="full"
        type="outlined"
        buttonType="button"
        className={className}>
        <WalletIcon width={iconSize} height={iconSize} />
        <span className="text-[14px]">{label}</span>
        {trailing}
      </Button>
      {started ? (
        <Suspense fallback={null}>
          <WalletSiweSession
            disconnectIfConnected={disconnectIfConnected}
            onReady={() => setLoading(false)}
            onError={() => setLoading(false)}
          />
        </Suspense>
      ) : null}
    </>
  )
}
